import { Stack, Typography } from "@mui/material";
import type { DrillDownPage } from "../../../../store/types/drillDownPageState.types";
import { getActiveLayer } from "../../../../store/utils/getActiveLayer";
import SourceColumnLinks from "./SourceColumnLinks";

interface Props {
  configuration: DrillDownPage;
}

export const PortfolioMonitoringTitle = ({ configuration }: Props) => {
  const activeLayer = getActiveLayer(configuration);
  const measureCaption =
    activeLayer.measure?.config.customLabel ||
    activeLayer.measure?.config.systemLabel ||
    activeLayer.measure?.meta.caption;
  const sourceFields = activeLayer.info?.combined.valueTargetFields ?? [];

  return (
    <Stack sx={{ py: 1.5, gap: 0.3 }}>
      <Typography variant="h6">Portfolio Monitoring Ledger</Typography>
      <Stack direction="row" sx={{ gap: 1, alignItems: "center" }}>
        {measureCaption && (
          <Typography variant="caption" color="textSecondary">
            {measureCaption} &#xa0;&bull;
          </Typography>
        )}
        {activeLayer.cell.formattedValue && (
          <Typography variant="caption" color="textSecondary">
            {activeLayer.cell.formattedValue}
          </Typography>
        )}
        {sourceFields.length > 0 && (
          <Typography variant="caption" color="textSecondary">
            <SourceColumnLinks fields={sourceFields} />
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};
export default PortfolioMonitoringTitle;
